import {
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  Char__minus_impl_a2frrhw2puetaduxyd as Char__minus_impl_a2frrh,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function isAsciiDigit(_this__u8e3s4) {
  return _Char___init__impl__6a9atx(48) <= _this__u8e3s4 ? _this__u8e3s4 <= _Char___init__impl__6a9atx(57) : false;
}
function asciiDigitToInt(_this__u8e3s4) {
  return Char__minus_impl_a2frrh(_this__u8e3s4, _Char___init__impl__6a9atx(48));
}
//region block: exports
export {
  asciiDigitToInt as asciiDigitToInt1lum15k9ieezj,
  isAsciiDigit as isAsciiDigit3p3aq858xklh,
};
//endregion

//# sourceMappingURL=util.mjs.map
